import script from "./TournamentsVue.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentsVue.vue?vue&type=script&setup=true&lang=js"

import "./TournamentsVue.vue?vue&type=style&index=0&id=426ee5f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426ee5f4"]])

export default __exports__